import React, { ReactElement } from 'react';
import { FormulaireCreationEntite } from '../../Utils/FormulaireCreationEntite';
import { ChampsActiviteEntenteProduit, DetailsHistoriquePrixProduitProps } from './DetailsActiviteEntenteProduit';
import ActiviteEntenteProduit from '../../../../../../common/src/entities/activite-entente-produit.entity';

export const CreerActiviteEntenteProduit = (props: DetailsHistoriquePrixProduitProps): ReactElement => {
    const { succes, indexActiviteEntenteProduit, entente } = props;
    return (
        <FormulaireCreationEntite
            texteEntete={(t: ActiviteEntenteProduit) => <small className="text-muted">Ajout d&apos;un produit</small>}
            noSave
            entite={ActiviteEntenteProduit}
            modal
            succes={succes}
        >
            <ChampsActiviteEntenteProduit indexActiviteEntenteProduit={indexActiviteEntenteProduit} entente={entente} />
        </FormulaireCreationEntite>
    );
};
